import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import type { StaffRewardListQuery, StaffRewardItem } from "../../types";
import { RewardItem } from "./components/RewardItem";

const BRAND = "#FF6B35";

// ═══ 模拟 API ═══
async function mockGetRewardMoney(): Promise<string> {
  return new Promise((r) => setTimeout(() => r("680.00"), 300));
}

async function mockGetRewardList(query: Record<string, unknown>): Promise<{ data: StaffRewardItem[] }> {
  return new Promise((r) =>
    setTimeout(() => r({
      data: Array.from({ length: Number(query.limit) || 5 }, (_, i) => ({
        id: i + 1,
        item_name: `打赏-${i + 1}`,
        ordersn: `CR${Date.now()}${i}`,
        pay_price: (Math.random() * 200).toFixed(2),
        book_time_desc: "2026-04-30 15:00",
      })) as StaffRewardItem[],
    }), 400),
  );
}

export default function RewardPage() {
  const navigate = useNavigate();
  const [rewardMoney, setRewardMoney] = useState("");
  const [data, setData] = useState<StaffRewardItem[]>([]);
  const form = useRef<StaffRewardListQuery>({ limit: 10 });
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  useEffect(() => {
    mockGetRewardMoney().then(setRewardMoney);
    fetchList(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchList = async (reset = false) => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await mockGetRewardList({ ...form.current });
      setData(reset ? res.data : [...data, ...res.data]);
    } catch (err) {
      console.error("[Reward List Error]", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pb-[calc(env(safe-area-inset-bottom,0px)+80px)]" style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}>
      {/* Header */}
      <div className="bg-white px-5 flex items-center gap-3" style={{ paddingTop: "calc(env(safe-area-inset-top,0px) + 16px)", paddingBottom: 13, borderBottom: "1px solid #F5F5F5" }}>
        <button onClick={() => navigate(-1)} className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer active:scale-[0.98] transition-transform shrink-0" style={{ background: "#F3F4F6" }}>
          <i className="ri-arrow-left-line" style={{ fontSize: 20, color: "#374151" }} />
        </button>
        <span className="text-lg font-bold text-gray-800">打赏记录</span>
      </div>

      <div className="px-4 pt-4 space-y-3">
        {/* 打赏金额卡片 */}
        <div className="bg-white rounded-2xl p-5">
          <span className="text-xs text-gray-500">打赏总收益</span>
          <div className="text-3xl font-bold mt-2" style={{ color: BRAND }}>¥{rewardMoney || "0.00"}</div>
        </div>

        {/* 筛选栏 */}
        <div className="bg-white rounded-2xl px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <input type="date" value={startTime} onChange={(e) => setStartTime(e.target.value)} className="py-2 px-3 rounded-xl bg-gray-50 text-sm outline-none text-gray-700" />
            <input type="date" value={endTime} onChange={(e) => setEndTime(e.target.value)} className="py-2 px-3 rounded-xl bg-gray-50 text-sm outline-none text-gray-700" />
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <button onClick={() => fetchList(true)} className="px-4 py-2 rounded-full text-xs font-semibold text-white active:scale-[0.98]" style={{ background: BRAND }}>搜索</button>
            <button onClick={() => { setStartTime(""); setEndTime(""); fetchList(true); }} className="px-4 py-2 rounded-full text-xs font-semibold text-gray-600 bg-gray-100 active:scale-[0.98]">清除</button>
          </div>
        </div>

        {/* 列表 */}
        <div className="space-y-3 pb-4">
          {data.map((item) => (
            <RewardItem key={item.id} item={item} />
          ))}
          {!data.length && !loading && (
            <div className="pt-16 pb-8 text-center">
              <i className="ri-gift-line text-5xl block mx-auto mb-3 text-gray-200" />
              <p className="text-sm text-gray-400">暂无打赏记录</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
